<template>
  <div class="bg-gray-300 p-6 w-full">
    <form >
      <div class="flex">
        <div class="mr-2 w-1/2">
          <input
            :placeholder="$t('signin.firstname')"
            class="py-1 pl-2 outline-none w-full"
            :aria-label="$t('signin.firstname')"
            v-model="owner.firstname"
            required  >

        </div>
        <div class=" w-1/2">
          <input
            :placeholder="$t('signin.lastname')"
            class="py-1 pl-2 outline-none w-full"
            :aria-label="$t('signin.lastname')"
            v-model="owner.lastname"
            required  >
        </div>

      </div>

      <div class="form-row">
        <div id="iban-element" ref="iban" aria-label="iban"
          class="bg-white p-2 mt-4 w-full" @change="displayErrors($event)">
          <!-- A Stripe Element will be inserted here. -->
        </div>
      </div>
      <div id="error-message" class="italic text-b2c-red-300 text-sm"> {{errorMessage}}</div>

    </form>
    <button id="card-button" class="shadow-md text-sm px-4 py-2 mt-4 bg-white hover:text-white hover:bg-b2c-red-300 rounded"
      :class="isLoading ? 'loader' : ''" @click="createStripeSource()">
        {{ $t('iban.save') }}
    </button>
    <div id="mandate-acceptance" class="text-xs pt-2">
      By providing your IBAN and confirming this payment, you authorise
      (A) Salvi Music DE and Stripe, our payment service
      provider, to send instructions to your bank to debit your account and
      (B) your bank to debit your account in accordance with those instructions.
      You are entitled to a refund from your bank under the terms and
      conditions of your agreement with your bank. A refund must be claimed
      within 8 weeks starting from the date on which your account was debited.
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { getCustomerSepaSetupIntent } from '@/services/OrdersService';

// eslint-disable-next-line no-undef
const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
let iban = {};

export default {

  data() {
    return {
      owner: {
        firstname: '',
        lastname: '',
        email: '',
      },

      isLoading: false,

      errorMessage: '',

      options: {
        supportedCountries: ['SEPA'],
        placeholderCountry: this.$i18n.locale.toUpperCase(),
      },
    };
  },

  computed: {
    ...mapGetters({
      user: ['auth/user'],
      customer: ['auth/customer'],
      changedLocale: 'auth/changedLocale',
    }),

  },

  watch: {
    changedLocale() {
      this.options = {
        supportedCountries: ['SEPA'],
        placeholderCountry: this.$i18n.locale.toUpperCase(),
      };
      this.errorMessage = '';
      this.displayIban();
    },

  },

  mounted() {
    this.displayIban();

    this.owner.email = this.user.email;

    iban.on('change', (event) => {
      this.displayErrors(event);
    });
  },

  beforeDestroy() {
    iban.destroy(this.$refs.iban);
  },

  methods: {
    displayErrors(event) {
      if (event.error) {
        this.errorMessage = event.error.message;
      }
    },

    displayIban() {
      const elements = stripe.elements({
        locale: this.$i18n.locale,
      });
      iban = elements.create('iban', this.options);

      iban.mount(this.$refs.iban);
    },

    createStripeSource() {
      this.isLoading = true;
      getCustomerSepaSetupIntent(this.customer.id).then(({ data }) => {
        stripe.confirmSepaDebitSetup(
          data.client_secret,
          {
            payment_method: {
              sepa_debit: iban,
              billing_details: {
                name: `${this.owner.firstname} ${this.owner.lastname}`,
                email: this.owner.email,
              },
            },
          },
        ).then((result) => {
          if (result.error) {
            this.isLoading = false;
            this.createNotification('error', result.error.message);
            return;
          }
          axios.post(`/api/customers/${this.customer.id}/update-payment-method`, { payment_method: result.setupIntent.payment_method }).then(() => {
            this.$emit('updated-payment-method');
            this.isLoading = false;
          }).catch((error) => {
            this.isLoading = false;
            this.checkSessionErrorNotification(error);
          });
        });
      });
      /* const sourceData = {
        type: 'sepa_debit',
        currency: 'eur',
        owner: {
          name: `${this.owner.firstname} ${this.owner.lastname}`,
          email: this.owner.email,
        },
        mandate: {
          notification_method: 'email',
        },
      };

      console.log(sourceData);

      stripe.createSource(iban, sourceData).then((result) => {
        if (result.error) {
          this.errorMessage = result.error.message;
          return;
        }
        this.errorMessage = '';
        console.log(result.source);
        this.saveStripeSource(result.source);
      }); */
    },

    /* saveStripeSource(source) {
      axios.post(`/api/customers/${this.customer.id}/sepa-source`, { sourceId: source.id }).then(({ data }) => {
        console.log(data);
      }).catch((error) => {
        console.log(error);
      });
    }, */

    savePaymentMethod() {
      this.isLoading = true;
      stripe.confirmibanSetup(
        this.intent.client_secret, {
          payment_method: {
            iban,
            billing_details: { name: this.ibanHolder },
          },
        },
      ).then((result) => {
        if (result.error) {
          this.isLoading = false;
          this.createNotification('error', result.error.message);
          return;
        }
        axios.post(`/api/customers/${this.customer.id}/update-payment-method`, { payment_method: result.setupIntent.payment_method }).then(() => {
          this.$emit('updated-payment-method');
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          this.checkSessionErrorNotification(error);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
